import { Button } from '../../../cdl/Button/Button';
import { translate } from '../../../common/helpers/translate.helper';
import { IconPlus } from '../../../common/icons/cdl/Plus';
import { useCreateProductDrawer } from '../hooks/useCreateProductDrawer';

export const CreateProductButton = () => {
    const openCreateProductDrawer = useCreateProductDrawer();

    return (
        <Button emphasis="high" LeadingIcon={IconPlus} onClick={openCreateProductDrawer}>
            {translate('productsOverview.create')}
        </Button>
    );
};
